module.exports = __webpack_public_path__ + "img/bag.448b9daa.svg";